export function preventDefault(eventHandler) {
	return function(event) {
		event.preventDefault()
		eventHandler(event)
	}
}

export function onEscape(eventHandler) {
	return function(event) {
		if (event.keyCode === 27) {
			eventHandler()
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/events.js